import { get, post, del, put } from '@/libs/api.request'

export const getOrders = (params) => {
  return get('/orders', params)
}

export const getOrder = (orderId) => {
  return get(`/orders/${orderId}`)
}

export const createOrder = (attributes) => {
  return post('/orders', attributes)
}

export const deleteOrder = (orderId) => {
  return del(`/orders/${orderId}`)
}

export const updateOrder = (orderId, attributes) => {
  return put(`/orders/${orderId}`, attributes)
}

export const getOrderItems = (orderId) => {
  return get(`/orders/${orderId}/items`)
}

export const updateOrderItem = (itemId, attributes) => {
  return put(`/orders/items/${itemId}`, attributes)
}

export const removeOrderItem = (itemId) => {
  return del(`/orders/items/${itemId}`)
}

export const addOrderItem = (orderId, attributes) => {
  return post(`/orders/${orderId}/items`, attributes)
}

export const createOrderFromQuote = (quoteId) => {
  return post(`/orders/create-from-quote`, { quote_id: quoteId })
}

export const sendOrderToERP = (orderId) => {
  return post(`/orders/${orderId}/send-to-erp`)
}

export const sendOrderToQBO = (orderId) => {
  return post(`/orders/${orderId}/send-to-qbo`)
}

export const createOrderChangeRecord = (orderId, data) => {
  return post(`/orders/${orderId}/change-records`, data)
}

export const getOrderChangeRecords = (orderId) => {
  return get(`/orders/${orderId}/change-records`)
}

export const updateOrderChangeRecord = (recordId, data) => {
  return put(`/orders/change-records/${recordId}`, data)
}

export const deleteOrderChangeRecordItem = (itemId) => {
  return del(`/orders/change-records/items/${itemId}`)
}

export const getOrderChangeRecordItems = (recordId) => {
  return get(`/orders/change-records/${recordId}/items`)
}

export const createQuoteFromOrderChangeRecord = (recordId) => {
  return post(`/orders/change-records/${recordId}/create-as-quote`)
}

export const getErpOrder = (orderId) => {
  return get(`/orders/${orderId}/erp-order`)
}

export const getErpOrderPrepays = (orderId) => {
  return get(`/orders/${orderId}/prepays`)
}
